/**
 * hidden_features — ONE switch to hide product areas from the app (menu, quick-jump,
 * cross-links, page URLs → /feature-hidden, APIs → 410, schedulers skipped).
 * 2026-09-06: Content Studio, Websites, Conversational AI, Social & Ads, AI Autopilot
 * and the Overview extras were first hidden here, then DELETED from the repo
 * (see DELETION-2026-09-06.md). The lists are empty now; the mechanism stays.
 *
 * Hidden here means: gone from the sidebar and search, page URLs show a short
 * "not available" screen, their internal APIs answer 410, and their background
 * schedulers never start. The code stays in the repo until a later clean-up.
 *
 * What deliberately STAYS reachable: public URLs that customers may already
 * have shared or embedded (hosted chat widget /chat + its runtime API, published
 * /site pages, /demo, booking, forms, tracking). Set HIDE_PUBLIC_RUNTIME=1 to
 * close those too.
 *
 * Edge-safe (imported by middleware): no Node imports, no DB.
 */

// Sidebar categories (SidebarNav.js menuItems[].category)
export const HIDDEN_SECTIONS = [];   // 2026-09-06: the hidden areas were DELETED from the repo; keep this switch for future use

// Page URL prefixes (matched as `=== p` or `startsWith(p + '/')`).
export const HIDDEN_PAGE_PREFIXES = [];

// Internal API prefixes (410). Public runtime endpoints are listed separately below.
export const HIDDEN_API_PREFIXES = [];
// /api/social/* is hidden except the unsubscribe link inside already-sent messages.
export const HIDDEN_API_PREFIXES_WITH_EXCEPTIONS = [];

// Public runtime that existing customers/prospects may already be using.
export const PUBLIC_RUNTIME_PAGES = [];
export const PUBLIC_RUNTIME_APIS = [];

// Background schedulers (labels in scheduler_bootstrap.js REGISTERED) that belong to hidden areas.
export const HIDDEN_SCHEDULER_PATTERNS = [];

const hit = (list, pathname) => list.some((p) => pathname === p || pathname.startsWith(p + '/'));

export function isHiddenPage(pathname) {
  if (hit(HIDDEN_PAGE_PREFIXES, pathname)) return true;
  if (process.env.HIDE_PUBLIC_RUNTIME === '1' && hit(PUBLIC_RUNTIME_PAGES, pathname)) return true;
  return false;
}

export function isHiddenApi(pathname) {
  if (hit(HIDDEN_API_PREFIXES, pathname)) return true;
  for (const { prefix, except } of HIDDEN_API_PREFIXES_WITH_EXCEPTIONS) {
    if (hit([prefix], pathname) && !hit(except, pathname)) return true;
  }
  if (process.env.HIDE_PUBLIC_RUNTIME === '1' && hit(PUBLIC_RUNTIME_APIS, pathname)) return true;
  return false;
}

export function isHiddenHref(href) {
  if (!href || typeof href !== 'string' || href.startsWith('http') || href.startsWith('#')) return false;
  return isHiddenPage(href.split('?')[0]);
}

export function isHiddenScheduler(label) {
  return HIDDEN_SCHEDULER_PATTERNS.some((re) => re.test(String(label || '')));
}
